import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const getPendingReplacementsData = async ({ url }) => {
  return request.get(url);
};

export const getPendingReplacementFlag = async () => {
  const url = '/feature-flag/replacement-visibility';
  return request.get(url);
};
